
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/koniec-lyziarskej-sezony-predpoklad",
      function () {
        return require("private-next-pages/[region]/koniec-lyziarskej-sezony-predpoklad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/koniec-lyziarskej-sezony-predpoklad"])
      });
    }
  